import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-reminder-popup',
    standalone: true,
    imports: [CommonModule, MatIcon, MatDialogModule, TranslateModule],
    templateUrl: './reminder-popup.component.html',
})
export class ReminderPopupComponent {
    constructor(private dialogRef: MatDialogRef<ReminderPopupComponent>) {}

    addMore() {
        this.dialogRef.close('add more');
    }

    onContinue() {
        this.dialogRef.close('continue');
    }
}
